/* RINCON EXCLUSIVE · rx-home.js · v2 — sin dependencias.
   Regla de seguridad: el contenido NUNCA se oculta si el JS no corre.
   1) Marcamos <html> con .rx-js inmediatamente; el CSS solo oculta bajo .rx-js
   2) Failsafe: a los 2.5s todo lo pendiente se muestra sí o sí. */
document.documentElement.classList.add('rx-js');
(function () {
  if (window.__rxHome) return;
  window.__rxHome = true;

  function showAll() {
    document.querySelectorAll('[data-rx-reveal]:not(.rx-in)').forEach(function (el) { el.classList.add('rx-in'); });
  }

  function initReveals(root) {
    var items = (root || document).querySelectorAll('[data-rx-reveal]:not(.rx-in)');
    if (!('IntersectionObserver' in window)) { showAll(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('rx-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -4% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  function initVideos(root) {
    (root || document).querySelectorAll('.rx-ed__media video, .rx-hero__media video').forEach(function (v) {
      v.muted = true;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { v.play().catch(function () {}); } else { v.pause(); }
        });
      }, { threshold: 0.2 });
      io.observe(v);
    });
  }

  function initAll() { initReveals(); initVideos(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else { initAll(); }

  /* Failsafe absoluto */
  setTimeout(showAll, 2500);

  document.addEventListener('shopify:section:load', function (e) {
    initReveals(e.target); initVideos(e.target);
  });
})();
